/**
 * Информация о скролле, фичи для скролла
 * @packageDocumentation
 */

import { offset } from '@/core/utils/dom';

/**
 * Добавить классы модификаторов тени в зависимости от скролла элемента
 *
 * @todo Сделать приватной
 */
export const genHasScroll = (el: HTMLElement): void => {
	if (!el) return;
	if (!el.parentElement) return;
	if (!el.offsetHeight) return;

	// Диалоги не вынесены в UI
	if (window['dialogs']) {
		const elDialog = el.closest('.ui-dialog');
		if (elDialog?.getBoundingClientRect() && elDialog?.getBoundingClientRect().bottom > document.documentElement.clientHeight) {
			setTimeout(window['dialogs'].onWindowResize);
		}
	}

	const hasScroll = (el.scrollHeight > el.offsetHeight);
	if (hasScroll) {
		el.parentElement.classList.add('has_scroll_container');
		el.classList.add('has_scroll');
	} else {
		el.parentElement.classList.remove('has_scroll_container');
		el.classList.remove('has_scroll');
	}

	if (hasScroll) {
		const top: number = offset(el).top - offset(el.parentElement).top;
		el.style.setProperty('--scroll-offset-top', top + 'px');

		const height = el.offsetHeight;
		el.style.setProperty('--scroll-height', height + 'px');

		if (el.scrollTop > 0) {
			el.classList.add('has_scroll-started');
		} else {
			el.classList.remove('has_scroll-started');
		}

		if (el.scrollTop >= el.scrollHeight - el.offsetHeight) {
			el.classList.add('has_scroll-finished');
		} else {
			el.classList.remove('has_scroll-finished');
		}
	}
};

let scrollShadowResizeObserver: ResizeObserver;
if (window.ResizeObserver) {
	scrollShadowResizeObserver = new ResizeObserver((entries) => {
		entries.forEach((entry) => genHasScroll(entry.target as HTMLElement));
	});
}

/**
 * Добавить отображение тени при появлении скролла у элемента
 *
 * Будут добавлены события для усатновки модификаторов тени в зависимости от скролла элемента
 *
 * Модификаторы:
 * - top-scrollShadow
 * - top-scrollShadow-started
 * - top-scrollShadow-finished
 */
export const connectScrollShadow = (els: HTMLElement | HTMLElement[]) => {
	if (!els) return;

	if (Array.isArray(els)) {
		els.forEach((el) => connectScrollShadow(el));

		return;
	}

	const el = els;

	if (el.dataset.scrollShadowInited) return;
	el.dataset.scrollShadowInited = 'true';

	el.onscroll = () => genHasScroll(el);

	scrollShadowResizeObserver?.observe(el);
};

export const unconnectScrollShadow = (el: HTMLElement) => {
	scrollShadowResizeObserver?.unobserve(el);
};

/**
 * Посчитать глубину скролла (процент на сколько проскроллена страница)
 *
 * @deprecated
 */
export const amountScrolled = (): number => {
	return getScrollPercent();
};

/**
 * Получить прогресс скролла в процентах
 */
export const getScrollPercent = (el: HTMLElement = document.documentElement): number => {
	const clientHeight = el.clientHeight;
	const scrollHeight = el.scrollHeight;
	const scrollTop = el.scrollTop;

	if (scrollHeight && scrollTop && clientHeight) {
		const trackLength = scrollHeight - clientHeight;

		return Math.floor(scrollTop / trackLength * 100);
	}

	return 100;
};
